import { useEffect } from 'react';

export function useStepNavigation(step, location, navigate, setStep) {
	useEffect(() => {
		if (step === 1 && location.pathname !== '/pages/subscriptions') {
			navigate('/pages/subscriptions');
		}

		if (step === 2 && location.pathname !== '/pages/subscriptions/details') {
			navigate('/pages/subscriptions/details');
		}

		if (step === 3 && location.pathname !== '/pages/subscriptions/configuration') {
			navigate('/pages/subscriptions/configuration');
		}

		if (step === 4 && location.pathname !== '/pages/subscriptions/summary') {
			navigate('/pages/subscriptions/summary');
		}

		if (step === 5 && location.pathname !== '/pages/subscriptions/thank-you') {
			navigate('/pages/subscriptions/thank-you');
		}

		if (
			(step === 1 && location.pathname == '/pages/subscriptions/details') ||
			(step === 1 && location.pathname == '/pages/subscriptions/configuration')
		) {
			setStep(2);
		}

		if (document.querySelector('.page-wrapper--extra-content')) {
			const allExtraContent = document.querySelectorAll('.page-wrapper--extra-content');
			allExtraContent.forEach((el) => {
				if (el.dataset.stepExtraContent !== step.toString()) {
					el.classList.add('is-hidden');
				} else {
					el.classList.remove('is-hidden');
				}
			});
			window.dispatchEvent(new Event('resize'));
		}
	}, [step]);
}
